// extracted by mini-css-extract-plugin
var _1 = "EmailMessageDragOverlay-moduleEmailMessageDragOverlay__gCUEw";
var _2 = "EmailMessageDragOverlay-modulecontent__a2L8h";
var _3 = "EmailMessageDragOverlay-moduledragging__znrIj";
var _4 = "EmailMessageDragOverlay-moduleover__1V88s";
var _5 = "EmailMessageDragOverlay-moduleshadow__y9Xwq";
var _6 = "EmailMessageDragOverlay-moduletext__tgNjw";
export { _1 as "EmailMessageDragOverlay", _2 as "content", _3 as "dragging", _4 as "over", _5 as "shadow", _6 as "text" }
